export default "__VITE_ASSET__fFkPCuEB__"